import { authenticatedPatch } from '../../../../../../api/request';

export default async function updateAvailability(idDoctorUser, availabilityBody, setErrorMessage) {
    const onFail = () => setErrorMessage('Ocurrió un error guardando la actualización de la disponibilidad.');
    const url = `/doctor-profile-management/availability/${idDoctorUser}`;
    return await authenticatedPatch(url, onFail, availabilityBody);
}
